import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Merlin2023RoutingModule } from './merlin2023-routing.module';
import { IconComponent } from './icon/icon.component';
import { UserlayoutComponent } from './userlayout/userlayout.component';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FileSaverModule } from 'ngx-filesaver';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SharedMaterialModule } from '../shared/shared-material.module';
import { ProjectmapComponent } from './projectmap/projectmap.component';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { AllProjctsComponent } from './all-projcts/all-projcts.component';

@NgModule({
  declarations: [
    IconComponent,
    UserlayoutComponent,
    ProjectmapComponent,
    AllProjctsComponent
  ],
  imports: [
    CommonModule,
    Merlin2023RoutingModule,
    RouterModule,
    CommonModule,
    FormsModule,
    SharedMaterialModule,
    NgScrollbarModule,
    FileSaverModule,
    NgxChartsModule,
  ],
  exports: [IconComponent,
    UserlayoutComponent,
    AllProjctsComponent
    ]
})
export class Merlin2023Module { }
export const userRoutes: Routes = [
  {
    path: "",
    children: [
      {
        path: "map",
        component: ProjectmapComponent
      }
    ]
  }
]
